import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Chat from "../../SignalR/Chat";
import { Modal, Button } from "react-bootstrap";
import { AiOutlineMessage } from "react-icons/ai";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

const ListaUsuarios = () => {
  const apiKey = localStorage.getItem("apiKey");
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [usuarios, setUsuarios] = useState([]);
  const [coordinadorSeleccionado, setCoordinadorSeleccionado] = useState(null);
  const [buscador, setBuscador] = useState("");
  const [emailMensaje, setEmailMensaje] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [programaID, setProgramaID] = useState("");
  const [chatAbierto, setChatAbierto] = useState(false);
  const navigate = useNavigate();
  const [programasUsuario, setProgramasUsuario] = useState([]);

  const programas = useSelector((state) => state.programas.Programas);

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        let response = await fetch(`${apiUrl}/Usuarios`);
        if (response.ok) {
          let data = await response.json();
          setUsuarios(data);
        } else {
          console.error("Error al obtener usuarios");
        }
      } catch (error) {
        console.error("Error en la solicitud", error);
      }
    };
    fetchUsuarios();
  }, []);

  const handleBuscadorChange = (event) => {
    setBuscador(event.target.value);
  };

  const usuariosFiltrados = usuarios.filter((usuario) =>
    usuario.nombre.toLowerCase().includes(buscador.toLowerCase())
  );

  const abrirChat = (email) => {
    setChatAbierto(!chatAbierto);
    setEmailMensaje(email);
  };

  const abrirModal = (coordinador) => {
    setMostrarModal(true);
    setCoordinadorSeleccionado(coordinador);
    fetchProgramasPorUsuario(coordinador.email);
  };

  const fetchProgramasPorUsuario = async (email) => {
    setProgramasUsuario([]);
    try {
      const response = await fetch(
        `${apiUrl}/Usuarios/obtenerProgramasDeUsuario?mail=${email}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
          },
        }
      );
      const data = await response.json();
      setProgramasUsuario(data);
    } catch (error) {
      console.error("Error fetching programas:", error);
    }
  };

  const desAsignar = async (programa) => {
    try {
      const response = await fetch(`${apiUrl}/Usuarios/DesAsignarCoordinador`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apiKey: apiKey,
        },
        body: JSON.stringify({
          email: coordinadorSeleccionado.email,
          idPrograma: programa.id,
        }),
      });
      if (response.ok) {
        toast.success(`Se desasigno correctamente`, {
          position: "bottom-center",
          autoClose: 3000,
        });
        setMostrarModal(false);
      } else {
        console.error("Error al desAsignar programa");
      }
    } catch (error) {
      console.error("Error en la solicitud", error);
    }
  };

  const asignarCoordinador = async () => {
    try {
      const response = await fetch(`${apiUrl}/Usuarios/AsignarCoordinador`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apiKey: apiKey,
        },
        body: JSON.stringify({
          email: coordinadorSeleccionado.email,
          idPrograma: programaID,
        }),
      });
      if (response.ok) {
        toast.success(`Se asigno correctamente`, {
          position: "bottom-center",
          autoClose: 3000,
        });
        setMostrarModal(false);
      } else {
        console.error("Error al asignar programa");
      }
    } catch (error) {
      console.error("Error en la solicitud", error);
    }
  };

  const handleSelectCambio = (e) => {
    setProgramaID(e.target.value);
  };

  return (
    <div className="container mb-12 mt-3">
      <h2 className="mb-3">Lista de Usuarios</h2>
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar por nombre"
          value={buscador}
          onChange={handleBuscadorChange}
        />
      </div>

      {/* Contenedor con scroll vertical */}
      <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "hidden" }}>
        <table
          className="table table-striped"
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <thead>
            <tr>
              <th style={{ wordWrap: "break-word" }}>Nombre</th>
              <th style={{ wordWrap: "break-word" }}>Email</th>
              <th style={{ wordWrap: "break-word" }}>Rol</th>
              <th>Asignar Programa</th>
          
            </tr>
          </thead>
          <tbody>
            {usuariosFiltrados.map((usuario) => (
              <tr key={usuario.ID}>
                <td style={{ wordBreak: "break-word" }}>{usuario.nombre}</td>
                <td style={{ wordBreak: "break-word" }}>{usuario.email}</td>
                <td style={{ wordBreak: "break-word" }}>{usuario.rol}</td>
                <td>
                  {usuario.rol === "coordinador" && (
                    <Button
                      className="btn btnColorPrincipal"
                      onClick={() => abrirModal(usuario)}
                    >
                      Asignar
                    </Button>
                  )}
                </td>
               
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Chat isOpen={chatAbierto} paraQuien={emailMensaje} />

      <Button
        className="btn btnColorPrincipal form-control mt-3"
        onClick={() => navigate("/FormUsuario")}
      >
        Agregar Usuario
      </Button>

      <Modal show={mostrarModal} onHide={() => setMostrarModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Asignar programa al coordinador {coordinadorSeleccionado?.nombre} -{" "}
            {coordinadorSeleccionado?.email}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 mb-3">
            {programas.length === 0 ? (
              <div className="alert alert-warning" role="alert">
                No existen programas.
              </div>
            ) : (
              <select
                className="form-select"
                value={programaID}
                onChange={handleSelectCambio}
              >
                <option value="">Selecciona un programa</option>
                {programas.map((programa) => (
                  <option key={programa.id} value={programa.id}>
                    {programa.nombre}
                  </option>
                ))}
              </select>
            )}
          </div>
          <Button
            variant="primary"
            className="btnColorPrincipal"
            onClick={asignarCoordinador}
          >
            Asignar
          </Button>
        </Modal.Body>

        <Modal.Footer className="d-flex flex-column align-items-center">
          {programasUsuario.length === 0 ? (
            <div className="alert alert-warning w-100 text-center" role="alert">
              No tiene programas asignados.
            </div>
          ) : (
            <div className="w-100 mb-3">
              {programasUsuario.map((programa) => (
                <div
                  key={programa.id}
                  className="alert alert-info d-flex justify-content-between align-items-center"
                  role="alert"
                >
                  <span style={{ wordBreak: "break-word" }}>{programa.nombre}</span>
                  <IconButton
                    className="btn btn-link p-0"
                    onClick={() => desAsignar(programa)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))}
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() => setMostrarModal(false)}
            className="mb-2"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ListaUsuarios;
